export default __webpack_public_path__ + "static/contacts-5098d379b1939da098d80b638c0d6916.png";